import Conversation from "./Conversation/Conversation";
import Quiz from "./Quiz/Quiz";
import ClickReveal from "./ClickReveal/ClickReveal";
import TextEntry from "./TextEntry/TextEntry";
import VideoViewer from "./VideoViewer/VideoViewer";
import VideoClickReveal from "./ClickReveal/VideoClickReveal";
import Situation from "./Situation/Situation";
import Perspectives from './Perspectives/Perspectives';
import StackSorting from "./StackSorting/StackSorting";
import VideoConversation from "./VideoConversation/VideoConversation";
import VideoChoice from "./VideoChoice/VideoChoice";
import VideoRating from "./VideoRating/VideoRating";
import DragMatching from './DragMatching/DragMatching';
import LikertForm from "./LikertForm/LikertForm";
import SpeechEntry from "./TextEntry/SpeechEntry";
import CompareEntry from "./TextEntry/CompareEntry";
import PanelInterview from "./PanelInterview/PanelInterview";
import ThoughtDrag from "./ThoughtDrag/ThoughtDrag";
import TestActivity from "./TestActivity/TestActivity";

export default {
  Conversation,
  Perspectives,
  Quiz,
  VideoClickReveal,
  ClickReveal,
  VideoViewer,
  Situation,
  TextEntry,
  StackSorting,
  VideoConversation,
  VideoRating,
  VideoChoice,
  DragMatching,
  LikertForm,
  SpeechEntry,
  CompareEntry,
  PanelInterview,
  ThoughtDrag,
  TestActivity
};
